<template>
  <div class="zz-navbar">
    <div class="statusbar"></div>
    <div class="navbar">
      <div class="left item">
        <img
          src="@/assets/lucky/back.png"
          alt=""
          class="back"
          @click="$router.back()"
        />
      </div>
      <div class="title item">{{ title }}</div>
      <div class="right item"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style lang="less" scoped>
.zz-navbar {
  background: #fff;
}

.statusbar {
  height: var(--status-height);
}
.navbar {
  height: 4.4rem;
  display: flex;
  align-items: stretch;

  .item {
    flex: 1;
    padding: 0 1.2rem;
    display: flex;
    align-items: center;
  }

  .left,
  .right {
    flex: 0 0 8rem;
  }

  .right {
    justify-content: flex-end;
  }

  .title {
    justify-content: center;
    font-size: 1.6rem;
    font-weight: 700;
  }

  .back {
    width: 1.4rem;
    height: 1.4rem;
  }
}
</style>
